import ContractCoverageProfileCard from './ContractCoverageProfileCard';

export default ContractCoverageProfileCard;
